var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e59124",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-871 873 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -677.7,
    cy: 1016.6,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -698.4,
    cy: 1058.4,
    r: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-725.2,1078.3h-18.9H-763c-11.5,0-18.7,9.5-18.7,21.4v29.3h12.9v-25.9c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8 c0-1.2,1-2,2-2c1.2,0,2,1,2,2v25.8h12.9v-29.1C-706.2,1087.8-713.5,1078.3-725.2,1078.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -720.5,
    cy: 1016.6,
    r: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-671.1,1058.4c0,9.3,7.5,16.8,16.8,16.8s16.8-7.5,16.8-16.8c0-9.3-7.5-16.8-16.8-16.8S-671.1,1049.1-671.1,1058.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-672.8,1078.3c-11.5,0-18.7,9.5-18.7,21.4v29.3h12.9v-25.9c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8c0-1.2,1-2,2-2 c1.2,0,2,1,2,2v25.8h12.9v-29.1c0.2-12.1-7.1-21.6-18.7-21.6h-18.9h-19V1078.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -830.4,
    cy: 1058.4,
    r: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-855.4,1128.9v-25.8c0-1.2,1-2,2-2c1.2,0,2,0.8,2,2v25.8h41.5v-25.8c0-1.2,1-2,2-2c1.2,0,2,1,2,2v25.8h12.9v-29.1 c0.2-12.1-7.1-21.6-18.7-21.6h-18.9h-18.9c-11.5,0-18.7,9.5-18.7,21.4v29.3H-855.4L-855.4,1128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-760.9,1058.4c0,9.3,7.5,16.8,16.8,16.8c9.3,0,16.8-7.5,16.8-16.8c0-9.3-7.5-16.8-16.8-16.8 C-753.4,1041.6-760.9,1049.1-760.9,1058.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -808.9,
    cy: 1016.6,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -763.5,
    cy: 1016.6,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -786.1,
    cy: 1058.4,
    r: 16.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-743.1,979.8c28.6,0.3,51.5-23.4,51.6-51.4c0.3-28.6-22.7-51.4-51.4-51.6c-28.7-0.2-51.5,23.4-51.6,51.4 C-794.8,956.8-771.1,979.6-743.1,979.8z M-722.6,907.8c5.1,0.3,8.8,3.9,8.6,9c-0.3,5.1-3.9,8.8-9,8.6c-5.1-0.3-8.8-3.9-8.6-9 C-731.4,911.3-727.7,907.6-722.6,907.8z M-742.9,965.8c-12.5-0.1-23.7-7.4-29.4-19.5c-1-2.4,0.3-5.1,2.6-6.1c2.4-1,5.1,0.3,6.8,2.8 c3.7,8,11.5,13.2,20.3,13.4c8.8,0.2,16.4-5,20.1-13.1c1.3-2.7,4.3-3.6,6.4-2.5c2.7,1.3,3.8,3.7,2.5,6.4 C-718.7,958.5-730.4,966-742.9,965.8z M-761.7,907.8c5.1,0.3,8.8,3.9,8.6,9c-0.3,5.1-3.9,8.8-9,8.6c-4.4-0.1-8.8-3.9-8.6-9 C-770.6,912-766.8,907.6-761.7,907.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.346774094f9bc10c148d78980992ea84.svg";
export { ForwardRef as ReactComponent };